module.exports = __webpack_public_path__ + "img/img1.0c7fe158.png";